<style lang="scss">




@media screen and (min-width: 55rem) {
  .schoolsecret-container {
    margin-top: 5rem;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .schoolsecret {
      max-width: 1080px;
      width: 80%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      background-color: white;

      .schoolsecret-top {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        .schoolsecret-top-subtitle {
          font-size: 1rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: 500;
          color: #e5004f;
          line-height: 3.25rem;
          text-transform: uppercase;
        }
        .schoolsecret-top-title {
          font-size: 2rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: bold;
          color: #4b4b4b;
        }
        .schoolsecret-top-line {
          width: 2rem;
          height: 0.25rem;
          background-color: #e5004f;
          margin-top: 1rem;
        }
      }
      .schoolsecret-list {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        .schoolsecret-list-item {
          margin-top: 5rem;
          .schoolsecret-list-item-title {
            font-size: 1.6rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: bold;
            color: #7f7f7f;
            line-height: 23px;
            margin-bottom: 1rem;
          }
          .schoolsecret-list-item-text {
            font-size: 1rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: bold;
            color: #7f7f7f;
            line-height: 23px;
          }
        }
      }
      .schoolsecret-qrcode-container {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin-top: 10rem;
        .schoolsecret-qrcode-list {
          width: 80%;
          height: 20rem;
          display: flex;
          flex-direction: row;
          justify-content: space-around;
          align-items: center;
          .schoolsecret-qrcode-item {
            width: 15rem;
            height: 17rem;
            display: flex;
            flex-direction: column;
            align-items: center;

            .schoolsecret-qrcode-item-pic {
              width: 13rem;
              height: 13rem;
              background-image: url("/media/yintai/school-secret-1.png");
              background-size: 100% 100%;
            }
            .schoolsecret-qrcode-item-span {
              font-size: 20px;
              font-family:  'PingFang SC','Microsoft YaHei';
              font-weight: 400;
              color: #7f7f7f;
              line-height: 33px;
              margin-top: 0.5rem;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 55rem) {
  .schoolsecret-container {
    margin-top: 5rem;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .schoolsecret {
      max-width: 1080px;
      width: 80%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      background-color: white;

      .schoolsecret-top {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        .schoolsecret-top-subtitle {
          font-size: 1rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: 500;
          color: #e5004f;
          line-height: 3.25rem;
          text-transform: uppercase;
        }
        .schoolsecret-top-title {
          font-size: 2rem;
          font-family:  'PingFang SC','Microsoft YaHei';
          font-weight: bold;
          color: #4b4b4b;
        }
        .schoolsecret-top-line {
          width: 2rem;
          height: 0.25rem;
          background-color: #e5004f;
          margin-top: 1rem;
        }
      }
      .schoolsecret-list {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        .schoolsecret-list-item {
          margin-top: 5rem;
          .schoolsecret-list-item-title {
            font-size: 1.6rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: bold;
            color: #7f7f7f;
            line-height: 23px;
            margin-bottom: 1rem;
          }
          .schoolsecret-list-item-text {
            font-size: 1rem;
            font-family: 'PingFang SC','Microsoft YaHei';
            font-weight: bold;
            color: #7f7f7f;
            line-height: 23px;
          }
        }
      }
      .schoolsecret-qrcode-container {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin-top: 5rem;
        .schoolsecret-qrcode-list {
          width: 80%;
          height: 20rem;
          display: flex;
          flex-direction: row;
          justify-content: space-around;
          align-items: center;
          .schoolsecret-qrcode-item {
            width: 15rem;
            height: 17rem;
            display: flex;
            flex-direction: column;
            align-items: center;

            .schoolsecret-qrcode-item-pic {
              width: 13rem;
              height: 13rem;
              background-image: url("/media/yintai/school-secret-1.png");
              background-size: 100% 100%;
            }
            .schoolsecret-qrcode-item-span {
              font-size: 20px;
              font-family: 'PingFang SC','Microsoft YaHei';
              font-weight: 400;
              color: #7f7f7f;
              line-height: 33px;
              margin-top: 0.5rem;
            }
          }
        }
      }
    }
  }
}
</style>

<script>
export default {
  name: "schoolsecret",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
